var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile",style:({
  backgroundImage: 'url(' + _vm.item.background + ')',
  backgroundColor: _vm.item.overlay
})},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.item.text))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.item.url.url}},[_vm._v(_vm._s(_vm.item.cta))])])])}
var staticRenderFns = []

export { render, staticRenderFns }